import { Button, Card, Checkbox, Divider, Flex, Form, Image, Input, Space, theme, Drawer, Modal } from "antd";
import { useForm, useWatch } from "antd/es/form/Form";
import { EyeTwoTone, EyeInvisibleOutlined, GoogleOutlined, ArrowLeftOutlined } from "@ant-design/icons";

import { json, useNavigate } from "react-router-dom";
import SignUpService from "services/signup";

import { useEffect, useState } from "react";
import { useApp } from "contexts/app";

const signUpService = new SignUpService();


function Register() {
    const { token } = theme.useToken();
    const [form] = useForm();
    const [otpForm] = useForm();
    const { loading, showLoading } = useApp();


    const navigate = useNavigate();
    const [idOtp, setIdOtp] = useState();
    const [isShowOtp, setIshowOpt] = useState(false)

    const email = useWatch("email", { form });
    const agree = useWatch("agree", { form })

    const handleCreate = () => {
        form.submit();
    };
    useEffect(() => {
      //  form.setFieldsValue({ phone: "0911275168", pass: "112233", re_pass: "112233", full_name: "Vũ Văn Toàn", agree: true });

    }, [])


    const onFinish = async () => {

        const data = { ...form.getFieldsValue() };
        showLoading(true);
        var { otp } = await signUpService.signupWithPhone(data);
        // var { otp } = { "otp": { "id": "2247afbb-51b5-46c0-812c-e7692199b208" } };
        setIdOtp(otp.id);
        console.log()
        showLoading(false)
        setIshowOpt(true)

    };

    const onOtpFinish = async () => {
        const data = { ...otpForm.getFieldsValue() };
        console.log({ data, idOtp, post: { id: idOtp, otp: data.otp } });
        showLoading(true);
        try {
            var createdUser = await signUpService.createWithOTP({ id: idOtp, otp: data.otp });
            if (createdUser) {
                navigate("/thank-you")
            }
        } catch (error) {
            alert(error.message)
        }

        showLoading(false)

    }





    return (
        <Card style={{ width: "500px", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
            <Flex vertical gap={14}>
                <Space direction="vertical" style={{ textAlign: "center" }}>
                    <img width={200} style={{ borderRadius: "8px" }} src="https://storage.googleapis.com/cubebio/default/siprologo.png" />

                    <span style={{ fontSize: token.fontSizeHeading3, fontWeight: "500" }}>Sỉ Pro - Bán sỉ chuyên nghiệp</span>
                    <span>Đăng ký ngay để sở hữu website bán sỉ chuyên nghiệp, tự động hóa mọi thao tác thủ công.  </span>
                </Space>



                <Form layout="vertical" form={form} initialValues={{}} onFinish={() => onFinish("signUp")}>
                    <Form.Item
                        label="Số điện thoại"
                        name="phone"
                        rules={[
                            {
                                required: true,
                                pattern: /^[0-9]{10}$/,
                                message: "Số điện thoại không đúng định dạng",

                            },

                            {
                                validator: async (_, value) => {

                                    return new Promise(async (r, e) => {

                                        try {
                                            var data = await signUpService.checkPhone(value);
                                            if (data.error) {
                                                e(new Error('Số điện thoại này đã được đăng ký rồi'));
                                                return;
                                            }
                                            r();

                                        } catch (error) {
                            
                                            e(new Error('Không thể kiểm tra số điện thoạii'));
                                        }

                                    })




                                },
                            }

                        ]}
                    >
                        <Input placeholder="Phone"></Input>
                    </Form.Item>

                    <Form.Item
                        label="Họ và tên"
                        name="full_name"
                        rules={[
                            { required: true, }
                        ]}
                        style={{ flex: 1 }}

                    >
                        <Input placeholder="Họ và tên"></Input>
                    </Form.Item>

                    {/* 
                    <Form.Item
                        label="Email"
                        name="email"
                        rules={[
                            {

                                type: "email",
                                message: `${email} is not a valid email`,
                            },
                        ]}
                    >
                        <Input placeholder="Email"></Input>
                    </Form.Item> */}

                    <Form.Item
                        label="Password"
                        name="pass"
                        rules={[
                            {
                                required: true,
                            },
                        ]}
                    >
                        <Input.Password placeholder="Password" iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} />
                    </Form.Item>

                    <Form.Item
                        label="RePassword"
                        name="re_pass"
                        rules={[
                            {
                                required: true,
                            },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue("pass") === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error("The two passwords do not match!"));
                                },
                            }),
                        ]}
                    >
                        <Input.Password placeholder="Password" iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} />
                    </Form.Item>


                    <Form.Item name="agree" valuePropName="checked" rules={[
                        {
                            validator: (_, value) =>
                                value ? Promise.resolve() : Promise.reject(new Error('Bạn phải đồng ý với chính sách dịch vụ')),
                        },
                    ]}>
                        <Checkbox > Tôi đồng ý <a href="#" target="_blank">  Terms of Service</a> ,  <a href="#" target="_blank">  Privacy Policy</a> .</Checkbox>

                    </Form.Item>

                    <Space direction="vertical" style={{ width: "100%" }} size={"large"}>
                        <Button type="primary" style={{ width: "100%" }} onClick={() => handleCreate()} >
                            Tạo tài khoản
                        </Button>




                        <Flex align="center" justify="center">
                            <span>Already have an account?</span>
                            <Button type="link" onClick={() => navigate("/login")}>
                                Login
                            </Button>
                        </Flex>
                    </Space>
                </Form>

            </Flex>
            <Modal
                title="Xác nhận otp"
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={isShowOtp}
                onOk={e => otpForm.submit()}
                onCancel={e => setIshowOpt(false)}
                onClose={e => setIshowOpt(false)}
                okText="Xác nhận"
            >

                <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>


                    <Form layout="vertical" form={otpForm} initialValues={{}} onFinish={onOtpFinish} style={{ width: 300 }} >

                        <Form.Item
                            label="OTP"
                            name="otp"
                            rules={[
                                {
                                    required: true,
                                },
                                {
                                    pattern: /^[0-9]{4}$/,
                                    message: "OTP must be a 4-digit number",
                                },
                            ]}
                        >
                            <Input.OTP length={4} style={{ width: "100%" }} />
                        </Form.Item>


                    </Form>
                </div>
            </Modal>
        </Card >
    );
}

export default Register;
